import { CustomerCareState } from "./types";

const state: CustomerCareState = {
  dashboards: [],
  selectedTab: "dashboard",
  editorVisible: false,
};

export default state;
